export const getOffsetTop = (
  element: HTMLElement | null,
  opts?: { finshWhenReaching: HTMLElement | string },
  isRecursiveCall?: boolean
): number => {
  if (!element) return 0

  if (opts?.finshWhenReaching && isRecursiveCall) {
    let checkHasReachedThisElement: HTMLElement | null = null
    if (typeof opts.finshWhenReaching === 'string') {
      checkHasReachedThisElement =
        element.offsetParent?.querySelector(opts.finshWhenReaching) ?? null
    } else if (element.offsetParent?.contains(opts.finshWhenReaching)) {
      checkHasReachedThisElement = opts.finshWhenReaching
    }

    const hasReached = checkHasReachedThisElement
    if (hasReached instanceof HTMLElement) return 0
  }

  return element
    ? element.offsetTop +
        getOffsetTop((element?.offsetParent as HTMLElement) ?? null, opts, true)
    : 0
}
